


























































import Vue from 'vue'
import _ from 'lodash'
import { Drag, Drop } from 'vue-drag-drop'
import { FETCH_DASHBOARD_DATA, RESET_DASHBOARD_SETTINGS, UPDATE_DASHBOARD_SETTINGS } from '@/store/action-types'
import { DashboardData } from '@/model/dashboard/DashboardData'

interface Widget {
  id: number
  type: string
  name: string
  widgetId: number
  image?: string
}

interface ComponentData {
  widgetGrid: Widget[]
  widgetList: Widget[]
  dragging: number | undefined
  selectedPlace: Widget | undefined
  isSaveButtonDisabled: boolean
  showSnackbar: boolean
  snackbarState: boolean
  messageSnackbar: string
  data: Array<DashboardData>
  resetLoading: boolean
  saveLoading: boolean
}

export default Vue.extend({
  name: 'DashboardSettingsPage',

  components: {
    Drag,
    Drop
  },

  data (): ComponentData {
    return {
      widgetGrid: [],
      widgetList: [],
      dragging: undefined,
      selectedPlace: undefined,
      isSaveButtonDisabled: false,
      showSnackbar: false,
      snackbarState: false,
      messageSnackbar: '',
      data: [],
      resetLoading: false,
      saveLoading: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState
    }
  },

  methods: {
    selectedClass (item: Widget): string {
      if (item.type === 'chart') {
        return 'drop2'
      } else {
        return 'drop'
      }
    },

    handleDragover (group: Widget, data: any, event: any): void {
      this.selectedPlace = group
    },

    handleDrop (list: number, data: Widget, event: any): void {
      let newPositionIndex: number | undefined = undefined

      let foundItem: Widget | undefined = undefined

      if (list === 1) {
        foundItem = this.widgetGrid.find((item: Widget) => item.id === this.selectedPlace!.id)
        if (foundItem) {
          newPositionIndex = _.indexOf(this.widgetGrid, foundItem)
        }

      } else {
        foundItem = undefined
        newPositionIndex = undefined
      }

      if (foundItem) {
        if (this.dragging === 1) {

          let draggedWidget: Widget | undefined = this.widgetGrid.find((item: Widget) => item.id === data.id)
          if (draggedWidget) {
            let draggedWidgetIndex: number = _.indexOf(this.widgetGrid, draggedWidget)

            let list1: Widget[] = _.cloneDeep(this.widgetGrid)

            let b: Widget = list1[draggedWidgetIndex]

            list1[draggedWidgetIndex] = list1[newPositionIndex!]
            list1[draggedWidgetIndex].id = draggedWidgetIndex
            list1[newPositionIndex!] = b

            this.widgetGrid = list1
          }

        } else {

          let draggedWidget: Widget | undefined = this.widgetList.find((item: Widget) => item.id === data.id)

          if (draggedWidget) {
            let draggedWidgetIndex: number = _.indexOf(this.widgetList, draggedWidget)

            let list1: Widget[] = _.cloneDeep(this.widgetGrid)
            let list2: Widget[] = _.cloneDeep(this.widgetList)

            let b: Widget = list1[newPositionIndex!]

            if (b.type === 'placeholder') {
              list1.splice(newPositionIndex!, 1, draggedWidget)
              list2.splice(draggedWidgetIndex, 1)
            } else {
              list1.splice(newPositionIndex!, 1, draggedWidget)
              list2.splice(draggedWidgetIndex, 1, b)
            }

            this.widgetGrid = list1
            this.widgetList = list2
          }
        }

      } else {

        let draggedWidget: Widget | undefined = this.widgetGrid.find((item: Widget) => item.id === data.id)

        if (draggedWidget) {
          let draggedWidgetIndex: number = _.indexOf(this.widgetGrid, draggedWidget)

          let list1: Widget[] = _.cloneDeep(this.widgetGrid)
          let list2: Widget[] = _.cloneDeep(this.widgetList)

          list1.splice(draggedWidgetIndex, 1, { id: draggedWidgetIndex, type: 'placeholder', name: '', widgetId: 0 })
          list2.push(draggedWidget)

          this.widgetGrid = list1
          this.widgetList = list2
        }
      }
    },

    dragend () {
      this.dragging = undefined
    },

    async onResetClick (): Promise<void> {
      try {
        this.resetLoading = true
        const response = await this.$store.dispatch(RESET_DASHBOARD_SETTINGS)
        this.resetLoading = false
        if (response) {
          this.snackbarState = true
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved').toString()
          this.fetchDashboardData()
        } else {
          this.snackbarState = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        }
        this.showSnackbar = true
      } catch (e) {
        this.resetLoading = false
        this.snackbarState = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.showSnackbar = true
      }
    },

    async onSaveClick (): Promise<void> {

      let payload: any = []

      this.widgetGrid.forEach((item: Widget, index: number) => {
        if (item.type !== 'placeholder') {
          let rowPosition: number = 0
          let columnPosition: number = 0
          switch (index) {
            case 0:
              rowPosition = 1
              columnPosition = 1
              break
            case 1:
              rowPosition = 1
              columnPosition = 2
              break
            case 2 :
              rowPosition = 1
              columnPosition = 3
              break
            case 3 :
              rowPosition = 2
              columnPosition = 1
              break
            case 4 :
              rowPosition = 2
              columnPosition = 2
              break
            case 5 :
              rowPosition = 2
              columnPosition = 3
              break
            case 6 :
              rowPosition = 3
              columnPosition = 1
              break
            case 7 :
              rowPosition = 3
              columnPosition = 2
              break
            case 8 :
              rowPosition = 3
              columnPosition = 3
              break

          }

          payload.push(
            {
              'row_position': rowPosition,
              'column_position': columnPosition,
              'id_widget': item.widgetId
            }
          )
        }
      })

      try {
        this.saveLoading = true
        const response = await this.$store.dispatch(UPDATE_DASHBOARD_SETTINGS, payload)
        this.saveLoading = false
        if (response) {
          this.snackbarState = true
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved').toString()
        } else {
          this.snackbarState = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        }
        this.showSnackbar = true
      } catch (e) {
        this.saveLoading = false
        this.snackbarState = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.showSnackbar = true
      }
    },

    async fetchDashboardData (): Promise<void> {

      this.widgetGrid = [
        { id: 0, type: 'placeholder', name: '', widgetId: 0 },
        { id: 1, type: 'placeholder', name: '', widgetId: 0 },
        { id: 2, type: 'placeholder', name: '', widgetId: 0 },
        { id: 3, type: 'placeholder', name: '', widgetId: 0 },
        { id: 4, type: 'placeholder', name: '', widgetId: 0 },
        { id: 5, type: 'placeholder', name: '', widgetId: 0 },
        { id: 6, type: 'placeholder', name: '', widgetId: 0 },
        { id: 7, type: 'placeholder', name: '', widgetId: 0 },
        { id: 8, type: 'placeholder', name: '', widgetId: 0 },
      ]

      this.widgetList = [
        { id: 10, type: 'chart', name: this.$t('dashboard.chart1').toString(), widgetId: 1, image: 'Gantt' },
        { id: 11, type: 'chart', name: this.$t('dashboard.chart2').toString(), widgetId: 2, image: 'ColumnChart' },
        { id: 12, type: 'chart', name: this.$t('dashboard.chart3').toString(), widgetId: 3, image: 'PieChart' },
        { id: 13, type: 'chart', name: this.$t('dashboard.chart5').toString(), widgetId: 5, image: 'Messages' },
        { id: 14, type: 'chart', name: this.$t('dashboard.chart6').toString(), widgetId: 6, image: 'Table' },
        { id: 15, type: 'chart', name: this.$t('dashboard.chart7').toString(), widgetId: 7, image: 'ColumnInverseChart' },
        { id: 16, type: 'chart', name: this.$t('dashboard.chart8').toString(), widgetId: 8, image: 'Gantt' }
      ]

      this.data = await this.$store.dispatch(FETCH_DASHBOARD_DATA)

      this.data.forEach((item: DashboardData) => {
        let image: string = ''
        let id: number = 0

        if (item.code === 'w_schedule_daily') {
          image = 'Gantt'
          id = 10
        } else if (item.code === 'w_messages') {
          image = 'Messages'
          id = 13
        } else if (item.code === 'w_schedule_daily_table') {
          image = 'Table'
          id = 14
        } else if (item.code === 'w_capacity_percentage') {
          image = 'PieChart'
          id = 12
        } else if (item.code === 'w_capacity_by_employee') {
          image = 'ColumnChart'
          id = 11
        } else if (item.code === 'w_bvg_by_employee') {
          image = 'ColumnInverseChart'
          id = 15
        } else if (item.code === 'w_schedule_week') {
          image = 'Gantt'
          id = 16
        }

        const foundItem: Widget | undefined = this.widgetList.find((i: Widget) => i.widgetId === item.widgetId)

        if (foundItem) {
          let foundItemIndex: number = _.indexOf(this.widgetList, foundItem)
          this.widgetList.splice(foundItemIndex, 1)
        }

        if (item.rowPosition === 1 && item.columnPosition === 1) {
          this.widgetGrid.splice(0, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 1 && item.columnPosition === 2) {
          this.widgetGrid.splice(1, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 1 && item.columnPosition === 3) {
          this.widgetGrid.splice(2, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 2 && item.columnPosition === 1) {
          this.widgetGrid.splice(3, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 2 && item.columnPosition === 2) {
          this.widgetGrid.splice(4, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 2 && item.columnPosition === 3) {
          this.widgetGrid.splice(5, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 3 && item.columnPosition === 1) {
          this.widgetGrid.splice(6, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 3 && item.columnPosition === 2) {
          this.widgetGrid.splice(7, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        } else if (item.rowPosition === 3 && item.columnPosition === 3) {
          this.widgetGrid.splice(8, 1, {
            id: id,
            type: 'chart',
            name: item.widgetName,
            widgetId: item.widgetId,
            image: image
          })
        }
      })
    }

  },

  created () {
    document.documentElement.style.setProperty('--primary-color', this.$vuetify.theme.themes.light.primary!.toString())
    this.fetchDashboardData()
  }

})
